import isNil from 'lodash/isNil'
import defaultTo from 'lodash/defaultTo'
import moment from 'moment'

const endSubscriptionRetractionForm = {
    bindings: {
        contract: '<',
        onStateEnd: '&',
    },
    template: require('./endSubscriptionRetractionForm.jade')(),
    /** @ngInject */ controller(ApiService, Contract, ContractStatus, ContactTelephone, ErrorCatcher) {
        const ctrl = this
        ctrl.contactTelephone = ContactTelephone
        ctrl.contractStatus = ContractStatus
        ctrl.actionTypes = {
            bypassTrue: 'bypassTrue',
            bypassFalse: 'bypassFalse',
            selectEmmenagementDate: 'selectEmmenagementDate',
        }

        ctrl.state = 'state-initial'
        ctrl.hasAlreadyBypassed = false
        ctrl.activationDate = moment().add(14, 'days').format('D MMMM YYYY')
        ctrl.isEmmenagement = false
        ctrl.form = {
            isSubmit: false,
            action: ctrl.actionTypes.bypassTrue,
            emmenagementDate: null,
        }

        ctrl.isFormValid = function () {
            const isActionDefined = !isNil(ctrl.form.action)
            const isEmmenagementDateAfterToday = moment().isBefore(moment(ctrl.form.emmenagementDate, 'DDMMYYYY'), 'day')

            if (ctrl.form.action === ctrl.actionTypes.selectEmmenagementDate) {
                return isEmmenagementDateAfterToday
            }
            return isActionDefined
        }

        ctrl.submitForm = function () {
            ctrl.form.isSubmit = true
            if (ctrl.form.action === ctrl.actionTypes.bypassTrue) {
                Contract.bypassRetraction({ id: ctrl.contract.id }, {}).$promise
                .then(() => {
                    ApiService.resetPromise('userInfo')
                    ctrl.onStateEnd()
                })
                .catch((error) => {
                    ErrorCatcher.catchError(error)
                    ctrl.form.isSubmit = false
                })
            } else if (ctrl.form.action === ctrl.actionTypes.selectEmmenagementDate) {
                Contract.bypassRetraction({
                    id: ctrl.contract.id,
                    withDate: moment(ctrl.form.emmenagementDate, 'DDMMYYYY').format('YYYY-MM-DD'),
                }, {})
                .$promise
                .then(() => {
                    ApiService.resetPromise('userInfo')
                    ctrl.onStateEnd()
                })
                .catch((error) => {
                    ErrorCatcher.catchError(error)
                    ctrl.form.isSubmit = false
                })
            } else {
                ApiService.resetPromise('userInfo')
                ctrl.onStateEnd()
            }
        }

        ctrl.$onInit = function () {
            const retractionEndDate = moment(defaultTo(ctrl.contract.retraction_end_date, moment().add(14, 'days')))
            ctrl.activationDate = retractionEndDate.format('D MMMM YYYY')
            ctrl.isEmmenagement = ctrl.contract.is_a_move
            if (retractionEndDate.isSameOrBefore(moment(), 'day')) {
                ctrl.hasAlreadyBypassed = true
                ctrl.form.action = ctrl.actionTypes.bypassFalse
            }

            if ((ctrl.contract.channel === 'WEB') && (ctrl.contract.subscription_type === 'CDF')) {
                ctrl.state = 'state-web-cdf'
            } else if ((ctrl.contract.channel === 'WEB') && (ctrl.contract.subscription_type === 'MES')) {
                ctrl.state = 'state-web-mes'
            } else if ((ctrl.contract.channel === 'WEB') && (['CDF_INTER', 'MES_INTER', 'FIRST_MES'].includes(ctrl.contract.subscription_type))) {
                ctrl.state = 'state-web-mes-inter'
            } else if ((ctrl.contract.channel === 'TLV') && (ctrl.contract.subscription_type === 'CDF')) {
                ctrl.state = 'state-televente-cdf'
            } else if ((ctrl.contract.channel === 'TLV') && (ctrl.contract.subscription_type === 'MES')) {
                ctrl.state = 'state-televente-mes'
            } else if ((ctrl.contract.channel === 'TLV') && (['CDF_INTER', 'MES_INTER', 'FIRST_MES'].includes(ctrl.contract.subscription_type))) {
                ctrl.state = 'state-televente-mes-inter'
            } else {
                ctrl.state = 'state-unknown'
            }
        }
    },
}

export default endSubscriptionRetractionForm



// WEBPACK FOOTER //
// ./src/states/endSubscription/component/endSubscriptionRetractionForm.js